/* =========================================================
   Cart redesign behaviour
   - CART / WISHLIST tabs
   - Free sample selection (add/remove as free line items)
   - Gift card (stored as cart attribute) & promo code (/discount)
   Works in both the cart drawer and the /cart page.
   ========================================================= */
(function () {
  const cartRoutes = window.routes || {};
  const cartUpdateUrl = cartRoutes.cart_update_url || '/cart/update.js';
  const cartAddUrl = cartRoutes.cart_add_url || '/cart/add.js';
  const cartChangeUrl = cartRoutes.cart_change_url || '/cart/change.js';
  const cartUrl = cartRoutes.cart_url || '/cart';

  function jsonHeaders() {
    return { 'Content-Type': 'application/json', Accept: 'application/json' };
  }

  /* ---------- Re-render cart UI after a mutation ---------- */
  function replaceFromHtml(html, selectors) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    selectors.forEach((sel) => {
      const target = document.querySelector(sel);
      const source = doc.querySelector(sel);
      if (target && source) target.replaceWith(source);
    });
  }

  function refreshCartUI() {
    const tasks = [];

    if (document.querySelector('cart-drawer')) {
      tasks.push(
        fetch(`${cartUrl}?section_id=cart-drawer`)
          .then((r) => r.text())
          .then((html) => replaceFromHtml(html, ['cart-drawer-items', '.drawer__footer']))
      );
    }

    const mainItems = document.getElementById('main-cart-items');
    if (mainItems && mainItems.dataset.id) {
      tasks.push(
        fetch(`${cartUrl}?section_id=${mainItems.dataset.id}`)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const source = doc.querySelector('.js-contents');
            const target = mainItems.querySelector('.js-contents');
            if (source && target) target.innerHTML = source.innerHTML;
          })
      );
    }

    const mainFooter = document.getElementById('main-cart-footer');
    if (mainFooter && mainFooter.dataset.id) {
      tasks.push(
        fetch(`${cartUrl}?section_id=${mainFooter.dataset.id}`)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const source = doc.querySelector('.js-contents');
            const target = mainFooter.querySelector('.js-contents');
            if (source && target) target.innerHTML = source.innerHTML;
          })
      );
    }

    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      tasks.push(
        fetch(`${cartUrl}?section_id=cart-icon-bubble`)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const source = doc.querySelector('.shopify-section') || doc.body;
            if (source) bubble.innerHTML = source.innerHTML;
          })
      );
    }

    return Promise.all(tasks).then(() => syncCartCount());
  }

  /* ---------- Keep the CART (n) counts in sync ---------- */
  function syncCartCount() {
    const tabCounters = document.querySelectorAll('[data-cart-count]');
    const headerCounters = document.querySelectorAll('[data-wishlist-count]');
    if (!tabCounters.length && !headerCounters.length) return;
    fetch('/cart.js', { headers: jsonHeaders() })
      .then((r) => r.json())
      .then((cart) => {
        const count = cart.item_count;
        tabCounters.forEach((el) => {
          el.textContent = count;
        });
        headerCounters.forEach((el) => {
          el.textContent = '(' + count + ')';
        });
      })
      .catch(() => {});
  }

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    syncCartCount();

    setTimeout(async () => {
      await refreshCartUI();

      setTimeout(() => {
        enforceSampleLimit();
      }, 200);
    }, 500);
  });
}

  /* ---------- Tabs (CART / WISHLIST) ---------- */
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('.cart-tabs__tab');
    if (!tab) return;
    const tabsRoot = tab.closest('.cart-tabs');
    // Panels live in .drawer__inner (siblings of the topbar), so scope to the whole drawer.
    const drawer = tab.closest('cart-drawer') || document;
    const targetId = tab.getAttribute('data-tab-target');

    if (tabsRoot) {
      tabsRoot.querySelectorAll('.cart-tabs__tab').forEach((t) => {
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
    }
    drawer.querySelectorAll('.cart-tab-panel').forEach((panel) => {
      panel.hidden = panel.id !== targetId;
    });
    // The empty-cart message belongs to the Cart tab only.
    const emptyBlock = drawer.querySelector ? drawer.querySelector('.drawer__inner-empty') : null;
    if (emptyBlock) emptyBlock.style.display = targetId === 'CartDrawer-CartPanel' ? '' : 'none';
  });

  /* ---------- Free samples ---------- */

  async function enforceSampleLimit() {
  const samplesList = document.querySelector('[data-samples-limit]');
  if (!samplesList) return;

  const limit = parseInt(samplesList.dataset.samplesLimit || '0', 10);

  try {
    const response = await fetch('/cart.js', { headers: jsonHeaders() });
    const cart = await response.json();

    const sampleItems = cart.items.filter(
      (item) => item.properties && item.properties._sample
    );

    if (sampleItems.length <= limit) return;

    const excessSamples = sampleItems.slice(limit);

    for (const item of excessSamples) {
      await fetch(cartChangeUrl, {
        method: 'POST',
        headers: jsonHeaders(),
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      });
    }

    await refreshCartUI();
  } catch (error) {
    console.error('Unable to enforce free sample limit:', error);
  }
}
  function setSampleMessage(checkbox, text) {
    const wrap = checkbox.closest('[data-cart-samples]');
    const el = wrap ? wrap.querySelector('[data-samples-message]') : null;
    if (el) el.textContent = text || '';
  }

  document.addEventListener('change', (event) => {
    const checkbox = event.target.closest('[data-sample-checkbox]');
    if (!checkbox) return;

    const variantId = checkbox.value;
    setSampleMessage(checkbox, '');
    checkbox.disabled = true;

    if (checkbox.checked) {
      if (!variantId) {
        setSampleMessage(checkbox, window.cartEnhancementsStrings?.sampleUnavailable || 'This sample is unavailable.');
        checkbox.checked = false;
        checkbox.disabled = false;
        return;
      }
      fetch(cartAddUrl, {
        method: 'POST',
        headers: jsonHeaders(),
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _sample: 'true' } }] }),
      })
        .then((response) =>
          response.json().then((data) => {
            if (!response.ok) {
              throw new Error(data.description || data.message || 'add-failed');
            }
            return data;
          })
        )
        .then(() => refreshCartUI())
        .catch((err) => {
          checkbox.checked = false;
          checkbox.disabled = false;
          setSampleMessage(
            checkbox,
            err.message && err.message !== 'add-failed'
              ? err.message
              : window.cartEnhancementsStrings?.sampleUnavailable || 'This sample could not be added.'
          );
        });
    } else {
      // Remove the sample line by its key
      fetch('/cart.js', { headers: jsonHeaders() })
        .then((r) => r.json())
        .then((cart) => {
          const line = cart.items.find(
            (item) => String(item.variant_id) === String(variantId) && item.properties && item.properties._sample
          );
          if (!line) return;
          return fetch(cartChangeUrl, {
            method: 'POST',
            headers: jsonHeaders(),
            body: JSON.stringify({ id: line.key, quantity: 0 }),
          });
        })
        .then(() => refreshCartUI())
        .catch(() => {})
        .finally(() => {
          checkbox.disabled = false;
        });
    }
  });

  /* ---------- Gift card (stored as cart attribute) ---------- */
  function setMessage(scope, text, state) {
    const el = scope ? scope.querySelector('[data-discount-message]') : null;
    if (!el) return;
    el.textContent = text || '';
    el.classList.remove('is-error', 'is-success');
    if (state) el.classList.add(state);
  }

  function applyGiftCard(button) {
    const wrap = button.closest('[data-cart-discount]');
    const input = wrap.querySelector('[data-gift-card-input]');
    const code = (input.value || '').trim();
    button.disabled = true;
    fetch(cartUpdateUrl, {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify({ attributes: { 'Gift Card': code } }),
    })
      .then(() => refreshCartUI())
      .then(() => setMessage(wrap, code ? window.cartEnhancementsStrings?.giftSaved || 'Gift card saved — applied at checkout.' : '', code ? 'is-success' : null))
      .catch(() => setMessage(wrap, window.cartEnhancementsStrings?.error || 'Something went wrong.', 'is-error'))
      .finally(() => {
        button.disabled = false;
      });
  }

  /* ---------- Promo code (Shopify /discount endpoint) ---------- */
  function applyPromo(button) {
    const wrap = button.closest('[data-cart-discount]');
    const input = wrap.querySelector('[data-promo-input]');
    const code = (input.value || '').trim();
    if (!code) return;
    button.disabled = true;

    fetch(`/discount/${encodeURIComponent(code)}`, { method: 'GET' })
      .then(() => fetch('/cart.js', { headers: jsonHeaders() }))
      .then((r) => r.json())
      .then((cart) => {
        const applied = (cart.cart_level_discount_applications || []).some(
          (d) => (d.title || '').toUpperCase() === code.toUpperCase()
        );
        return refreshCartUI().then(() => {
          if (applied) {
            input.value = '';
            setMessage(wrap, window.cartEnhancementsStrings?.promoApplied || 'Promo code applied.', 'is-success');
          } else {
            setMessage(wrap, window.cartEnhancementsStrings?.promoInvalid || 'This code is not valid.', 'is-error');
          }
        });
      })
      .catch(() => setMessage(wrap, window.cartEnhancementsStrings?.error || 'Something went wrong.', 'is-error'))
      .finally(() => {
        button.disabled = false;
      });
  }

  document.addEventListener('click', (event) => {
    const giftBtn = event.target.closest('[data-gift-card-submit]');
    if (giftBtn) {
      event.preventDefault();
      applyGiftCard(giftBtn);
      return;
    }
    const promoBtn = event.target.closest('[data-promo-submit]');
    if (promoBtn) {
      event.preventDefault();
      applyPromo(promoBtn);
    }
  });

  // Submit promo/gift on Enter
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    if (event.target.matches('[data-promo-input]')) {
      event.preventDefault();
      const btn = event.target.closest('[data-cart-discount]').querySelector('[data-promo-submit]');
      if (btn) applyPromo(btn);
    } else if (event.target.matches('[data-gift-card-input]')) {
      event.preventDefault();
      const btn = event.target.closest('[data-cart-discount]').querySelector('[data-gift-card-submit]');
      if (btn) applyGiftCard(btn);
    }
  });
})();
